'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Utils


// Actions


// Components


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _editorStoreConnect = require('../../../../components/editor/store/components/editorStoreConnect');

var _editorStoreConnect2 = _interopRequireDefault(_editorStoreConnect);

var _editorStoreSelector = require('../../../../components/editor/store/reducers/editorStoreSelector');

var _editorActions = require('../../../../components/editor/store/editorActions');

var _Tool = require('../../Tool');

var _Tool2 = _interopRequireDefault(_Tool);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _richTextConstants = require('../../../../components/editor/richText/richTextConstants');

require('./RichTextTool.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapEditorStateToProps = function mapEditorStateToProps(state, ownProps) {
    var styleCommand = ownProps.styleCommand;

    var editorState = (0, _editorStoreSelector.getEditorState)(state);
    if (!editorState) return { isActive: false };

    var styleType = _richTextConstants.STYLE_COMMAND_TYPES[styleCommand];
    if (styleType === _richTextConstants.STYLE_TYPES.BLOCK) {
        var selection = editorState.getSelection();
        var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
        return { isActive: blockType === styleCommand };
    }

    var inlineStyle = editorState.getCurrentInlineStyle();
    return { isActive: inlineStyle.has(styleCommand) };
};

var mapEditorDispatchToProps = function mapEditorDispatchToProps(dispatch, ownProps) {
    return {
        handleMouseDown: function handleMouseDown(event) {
            event.preventDefault();
            var styleCommand = ownProps.styleCommand;

            dispatch((0, _editorActions.editorStyleChange)({ styleCommand: styleCommand }));
        }
    };
};

var RichTextTool = function RichTextTool(props) {
    var iconName = props.iconName,
        isActive = props.isActive;


    var iconNameOnOff = isActive ? iconName + '-on' : iconName;

    return _react2.default.createElement(
        _Tool2.default,
        _extends({}, props, { isActive: isActive }),
        _react2.default.createElement(_Icon2.default, { name: iconNameOnOff })
    );
};

RichTextTool.propTypes = {
    name: _propTypes2.default.string,
    iconName: _propTypes2.default.string.isRequired,
    styleCommand: _propTypes2.default.string,
    isActive: _propTypes2.default.bool
};

exports.default = (0, _editorStoreConnect2.default)(mapEditorStateToProps, mapEditorDispatchToProps)(RichTextTool);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/richContentTools/RichTextTool.js
// module id = 2248
// module chunks = 0